// Angular Imports
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
// Angular Material Imports
import { MatButtonModule } from '@angular/material/button'
import { MatRippleModule } from '@angular/material/core'
import { MatTooltipModule } from '@angular/material/tooltip'
// This Module Imports
// Shared Imports
import { EButtonColor, EIconButtonSize, TTooltipPosition } from '@shared/models'

@Component({
	selector: 'app-icon-button',
	standalone: true,
	imports: [MatButtonModule, MatRippleModule, MatTooltipModule],
	templateUrl: './icon-button.component.html',
	styleUrls: ['./icon-button.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconButtonComponent {
	@Input() buttonSize: keyof typeof EIconButtonSize = EIconButtonSize.normal
	@Input() color: keyof typeof EButtonColor = EButtonColor.inherit
	@Input() hasBackground: boolean = false
	@Input() isDisabled: boolean = false
	@Input() hasTooltip: string = ''
	@Input() tooltipPosition: TTooltipPosition = 'below'
	@Output() clicked = new EventEmitter<void>()

	readonly EIconButtonSize = EIconButtonSize
	readonly EButtonColor = EButtonColor

	emitClick() {
		this.clicked.emit()
	}
}
